import _typeof from "D:/coding/pmv5-fe/node_modules/@babel/runtime/helpers/esm/typeof.js";
// ========================================== 操作（菜单、按钮等）鉴权 ==========================================
import store from '@/config/store';
export var getOperateAuth = function getOperateAuth(auths, limit, hash) {
  var list;
  if (Array.isArray(auths)) {
    list = auths;
  } else if (typeof auths === 'string') {
    list = [auths];
  } else {
    list = [];
  }
  if (limit !== 'every' && limit !== 'some') limit = 'every';
  if (!hash || _typeof(hash) !== 'object') hash = store.state.authHash;
  if (list.length < 1) return true;
  if (limit === 'every' && list.every(function (p) {
    return hash[p];
  })) return true;
  if (limit === 'some' && list.some(function (p) {
    return hash[p];
  })) return true;
  return false;
};